import { useEffect } from 'react';
import BlogHeader from '../components/BlogHeader';
import NewsletterSignup from '../components/NewsletterSignup';
import Footer from '../../home/components/Footer';
import ArticleHero from './components/ArticleHero';
import ArticleIntro from './components/ArticleIntro';
import CredentialsSection from './components/CredentialsSection';
import ExperienceSection from './components/ExperienceSection';
import PricingSection from './components/PricingSection';
import TechnologySection from './components/TechnologySection';
import RedFlagsSection from './components/RedFlagsSection';
import ComparisonSection from './components/ComparisonSection';
import QuestionsSection from './components/QuestionsSection';
import ArticleConclusion from './components/ArticleConclusion';

export default function CompareTaxPreparationServicesPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": "How to Compare Tax Preparation Services in El Paso TX: The Complete Guide",
    "description": "Learn exactly how to compare tax preparation services in El Paso TX. Discover what credentials to look for, questions to ask, red flags to avoid, and how to find the right tax preparer for your business.",
    "author": { "@type": "Organization", "name": "El Paso QuickBooks Bookkeeping Services" },
    "publisher": { "@type": "Organization", "name": "El Paso QuickBooks Bookkeeping Services" },
    "datePublished": "2025-02-03",
    "dateModified": "2025-02-18",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://elpasoquickbooksbookkeeping.com/compare-el-paso-tax-preparation-services"
    },
    "keywords": "how to compare tax preparation services, El Paso TX, tax preparer, El Paso bookkeepers, QuickBooks bookkeeping service"
  };

  const faqData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What credentials should a tax preparer have in El Paso TX?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Look for Certified Public Accountants (CPAs), Enrolled Agents (EAs), or Annual Filing Season Program participants. All paid preparers must have a valid PTIN (Preparer Tax Identification Number). Verify credentials through the IRS online directory."
        }
      },
      {
        "@type": "Question",
        "name": "How much does tax preparation cost in El Paso TX?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Simple individual returns typically cost $150-$300, small business returns range from $400-$800, and S-Corp or partnership filings can cost $800-$2,000 depending on complexity. Always ask for a detailed breakdown of what the fee includes."
        }
      },
      {
        "@type": "Question",
        "name": "Should I use a national chain or local tax preparer in El Paso?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "For simple W-2 returns, national chains can be adequate. For business returns with multiple income streams, payroll, and industry-specific deductions, local El Paso preparers typically offer deeper expertise, year-round availability, and personalized service that national chains cannot match."
        }
      },
      {
        "@type": "Question",
        "name": "What are red flags when choosing a tax preparer?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Major red flags include promising unusually large refunds before reviewing documents, charging fees based on refund percentage, asking you to sign blank returns, refusing to e-file or sign the return, having no PTIN, and only being available during tax season."
        }
      }
    ]
  };

  const breadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://elpasoquickbooksbookkeeping.com/" },
      { "@type": "ListItem", "position": 2, "name": "Blog", "item": "https://elpasoquickbooksbookkeeping.com/blog" },
      { "@type": "ListItem", "position": 3, "name": "Compare Tax Preparation Services", "item": "https://elpasoquickbooksbookkeeping.com/compare-el-paso-tax-preparation-services" }
    ]
  };

  return (
    <div className="min-h-screen bg-white font-sans">
      <BlogHeader />
      <ArticleHero />
      <main>
        <article className="max-w-4xl mx-auto px-6 pb-16">
          <ArticleIntro />
          <CredentialsSection />
          <ExperienceSection />
          <PricingSection />
          <TechnologySection />
          <RedFlagsSection />
          <ComparisonSection />
          <QuestionsSection />
          <ArticleConclusion />
        </article>
      </main>
      <NewsletterSignup />
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqData) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbData) }}
      />
    </div>
  );
}
